import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, useAnimation } from '@angular/animations';
import { fadeInDown } from 'ng-animate';
import { FormBuilder, NgForm, FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { ApirequestService } from '../../../../services/apirequest/apirequest.service';
import { UtilityService } from '../../../../services/utilities/utilities.services';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';

@Component({
  selector: 'hybse-admin-create-demo-company',
  templateUrl: './create-demo-company.component.html',
  styleUrls: ['./create-demo-company.component.css'],
  animations: [
    trigger('fadeInDown', [transition('* => *', useAnimation(fadeInDown, {
      params: {
        timing: 1,
        a: '-10px'
      }
    }))])
  ],
})
export class CreateDemoCompanyComponent implements OnInit {
  public file: any;
  fadeInDown: any;
  createDemoCompanyForm: FormGroup;
  formResponseMsg: string = '';
  alertStatusMessage: boolean;
  showLoader: boolean = false;
  formSubmitted: boolean = false;

  constructor(private _fb: FormBuilder,
    private _req: ApirequestService,
    private _urls: ApiurlsService,
    private _utils: UtilityService,
    private route: ActivatedRoute,
    private router: Router) { }

  createDemoCompany() {
    let formVal = this.createDemoCompanyForm.value;
    this.formSubmitted = true;
    let seed = this;
    if (this.createDemoCompanyForm.valid) {
      this.showLoader = true;
      let data: any = {
        email: formVal.useremail,
        password: formVal.upass,
        companyName: formVal.companyName,
        ibin: formVal.ibinNO,
        initialValue: formVal.initialValue,
        isActive: formVal.userenabled,
        firstName: formVal.firstName,
        lastName: formVal.lastName

      };
      if (this.file) {
        data.uploadFile = this.file;
      }
      
      this._req.fetchApiData(this._urls.createDemoCompanyUrl, data).subscribe(
        (data: any) => {
          let response = data.data;
          let responseErr = data.error;
          this.showLoader = false;
          this.formSubmitted = false;
          this._utils.scrollToY(0, 400, 'easeInOutQuint');
          if (response != '') {
            this.formResponseMsg = 'Demo Company has been created Successfully';
            this.alertStatusMessage = true;
            setTimeout(() => {
              this.routeToPage();
            }, 2000);
          }
          if (responseErr != '') {
            this.formResponseMsg = responseErr['Error Msg'];
            this.alertStatusMessage = false;
          }
        },
        error => {
        },
        () => {
        });

    }
  }
  createDemoCompanyFormInit() {
    this.createDemoCompanyForm = this._fb.group({
      //'uname': ['', [Validators.required]],
      'upass': ['', [Validators.required]],
      'confirmpass': ['', [this.confirmPasswordCheck.bind(this, 0)]],
      'useremail': ['', [Validators.required, this.validateEmail]],
      'companyName': ['', [Validators.required]],
      'ibinNO': ['', [Validators.required]],
      'userenabled': ['1', [Validators.required]],
      'firstName': [null],
      'lastName': [null],
      'uploadFile': ['']
    },
      { updateOn: 'submit', validator: this.checkConfirmPassword }
    );

  }
  confirmPasswordCheck(i: any, input: any) {
    if (typeof this.createDemoCompanyForm != 'undefined') {
      let password = this.createDemoCompanyForm.controls['upass'].value;
      let confirmPass = this.createDemoCompanyForm.controls['confirmpass'].value;
      if ((password != confirmPass) && (confirmPass != '')) {
        return { pwInvalid: true };
      } else {
        return null;
      }
    }
    return null;
  }
  public fileUpload(event): void {
    this.file = event.target.files[0];

  }
  validateEmail(input: FormControl) {
    let val = input.value;
    let regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
    if (!regex.test(val) && val != '') {
      return {
        emailInvalid: true
      }
    }
    return null;
  }

  checkConfirmPassword(control: AbstractControl) {
    let password = control.get('upass').value;
    let confirmPassword = control.get('confirmpass').value;
    if ((password != confirmPassword) && password != '') {
      return {
        passwordInvalid: true
      }
    }
    return null;
  }

  cancelUserCreate() {
    this.routeToPage();
  }

  routeToPage() {
    this.router.navigate(['/demo-company/list']);
  }
  ngOnInit() {
    this.createDemoCompanyFormInit();
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/demo-company/create-demo-company/create-demo-company.component.ts